import { GetInstagramAudiosParams, InstagramAudio, getInstagramAudios } from '@round/api';
import { useCallback, useState } from 'react';
import { showNotification } from '../../../../helpers';

type Params = GetInstagramAudiosParams;

export function useInstagramAudios({ page, page_size, id }: Params) {
    const [audios, setAudios] = useState<InstagramAudio[]>([]);
    const [count, setCount] = useState(0);
    const [isInitialized, setIsInitialized] = useState(false);
    const [hasError, setHasError] = useState(false);

    const fetchAudios = async (params: Params, requestInit: RequestInit) => {
        try {
            const response = await getInstagramAudios(params, requestInit);
            if (response.status === 404) {
                setHasError(true);
                showNotification(response.data.detail, 'error');
                return;
            }

            setAudios(response.data.results);
            setCount(response.data.count);
            setIsInitialized(true);
        } catch (e) {
            if (e instanceof Error && e.name === 'AbortError') {
                return;
            }
            setHasError(true);
            showNotification(`Could not fetch instagram audios`, 'error');
        }
    };

    const init = useCallback(
        async (requestInit: RequestInit) => {
            await fetchAudios({ page, page_size, id }, requestInit);
        },
        [page, page_size, id]
    );

    const reset = () => {
        setAudios([]);
        setIsInitialized(false);
        setHasError(false);
    };

    return {
        audios,
        count,
        isInitialized,
        isLoading: !isInitialized && !hasError,
        hasError,

        init,
        reset,
    };
}
